import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints, Url } from '@rossum/api-client';
import {
  SuggestTriggerConditionResponse,
  SuggestTriggerConditionResult,
} from '@rossum/api-client/internal';
import { QueueRule } from '@rossum/api-client/schemas';
import { api } from '../../../lib/apiClient';
import { throwError } from '../../../redux/modules/messages/actions';

export const narrowTriggerConditionSuggestionResultToTemplate = (
  data: SuggestTriggerConditionResponse
): SuggestTriggerConditionResult[] =>
  data.results.map(r => ({
    triggerCondition: r.triggerCondition ?? '',
    triggerConditionSummary: r.triggerConditionSummary ?? '',
  }));

export const useSuggestTriggerCondition = () => {
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: ({
      search,
      schemaRule,
      queue,
    }: {
      search: string;
      schemaRule: Partial<QueueRule>;
      queue: Url;
    }) =>
      api.request(
        endpoints.internal.rules.suggestTriggerCondition({
          queue,
          userQuery: search,
          schemaRule,
        })
      ),
    onError: () => {
      dispatch(throwError('clientError'));
    },
  });

  return mutation;
};
